import { api } from "@/lib/api";

export const soApi = {
  state: () => api.get("/siteowner/state").then((r) => r.data),
  release: (payload) => api.post("/siteowner/release", payload).then((r) => r.data),
  book: (payload) => api.post("/siteowner/bookings", payload).then((r) => r.data),
  step: (id, action) => api.post(`/siteowner/bookings/${id}/${action}`).then((r) => r.data),
  overflow: (payload) => api.post("/siteowner/overflow", payload).then((r) => r.data),
  reclaim: (payload) => api.post("/siteowner/reclaim", payload).then((r) => r.data),
  maintenance: (payload) => api.post("/siteowner/maintenance", payload).then((r) => r.data),
  saveSettings: (payload) => api.put("/siteowner/settings", payload).then((r) => r.data),
  reset: () => api.post("/siteowner/reset").then((r) => r.data),
  setPlate: (id, plate) => api.post(`/siteowner/bookings/${id}/plate`, { plate }).then((r) => r.data),
  gate: () => api.get("/siteowner/gate").then((r) => r.data),
  createKey: (payload) => api.post("/siteowner/gate/keys", payload).then((r) => r.data),
  revokeKey: (id) => api.post(`/siteowner/gate/keys/${id}/revoke`).then((r) => r.data),
  testRead: (payload) => api.post("/siteowner/gate/test", payload).then((r) => r.data),
  resolveRead: (id, payload) => api.post(`/siteowner/gate/reads/${id}/resolve`, payload).then((r) => r.data),
};
